import { inject, Injectable, signal } from '@angular/core';
import { of, ReplaySubject } from 'rxjs';
import {
  catchError,
  first,
  switchMap,
  tap,
} from 'rxjs/operators';
import { StaticContentService } from './static-content.service';
import { BrandConfigService } from './brand-config/brand-config.service';
import { filterFirst } from 'ngx-unificator/rxjs';
import { UserService } from './user/user.service';
import { CookieService, DeviceDetectorService, PlatformService } from 'ngx-unificator/services';
import { Router } from '@angular/router';
import { isBot } from 'ngx-unificator/helpers';

@Injectable({
  providedIn: 'root'
})
export class RestrictSignupService {
  private _static = inject(StaticContentService);
  private _brandConfig = inject(BrandConfigService);
  private _user = inject(UserService);
  private _platform = inject(PlatformService);
  private _device = inject(DeviceDetectorService);
  private _router = inject(Router);
  private _cookies = inject(CookieService);

  /**
   * Use for hide sign up
   * @private
   */
  public isSignupRestricted = signal(false);

  /**
   * Use for hide sign up
   * @private
   */
  public isSignUpAvailable$ = new ReplaySubject(1);

  /**
   * Get Fr stags for enable registration
   */
  public checkRestrictSignup() {
    this._brandConfig.brandConfigResolved$.pipe(
      switchMap(() => {
        if (this._user.auth) {
          return of(false);
        }
        return this._static.item({slug: 'restrict-register'}).pipe(
          filterFirst(v => !!v),
          tap((data: {To403IfRegisteredOrStag: string}[]) => {
            this.isSignupRestricted.set(!!data?.length);
            this.isSignUpAvailable$.next(!data?.length);
            this._user.setAuthTranslateKey(!!data?.length);
            this._checkRestrictCountry(this.isSignupRestricted(), !!data?.[0]?.To403IfRegisteredOrStag);
          }),
          catchError((err) => {
            console.error('RestrictSignup error:', err);
            this.isSignupRestricted.set(false);
            this.isSignUpAvailable$.next(true);
            this._user.setAuthTranslateKey(false);
            return of(false);
          }),
        );
      }),
      first()
    ).subscribe();
  }

  /**
   * Check restrict country and redirect to 403 page
   * @private
   */
  private _checkRestrictCountry(isRestrictedFromCms: boolean = false, isCheckRegisteredOrStag: boolean = false) {
    if (this._platform.isBrowser) {
      const finalRestrict = isRestrictedFromCms && (isCheckRegisteredOrStag ? !(this._cookies.check('registered') || this._cookies.check('ptag')) : false);
      if (!isBot(this._device.userAgent) && finalRestrict) {
        setTimeout(() => {
          this._router.navigateByUrl('/403').then();
        }, 100);
      }
    }
  }

}
